export const SOCIALS = {
  TWITTER: "https://twitter.com/hailscale",
  INSTAGRAM: "https://www.instagram.com/hailscale/",
  FACEBOOK: "https://www.facebook.com/Hailscale-110010298297645",
  TIKTOK: "",
  LINKEDIN: "https://www.linkedin.com/company/hailscale/",
};